import * as Actions from '../../actions/estimate/type';

const initialState = {
  getPartsListLoading: false,
  partsList: [],
  error: '',
  loading: false,
  exportParts: '',

  importPartsSuppliesError: '',
  importPartsSuppliesData: '',
};
export const PartsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Parts  listing
    case Actions.GET_ALL_PARTS_LIST_REQUEST:
      return {
        ...state,
        getPartsListLoading: true,
      };
    case Actions.GET_ALL_PARTS_LIST_SUCCESS:
      return {
        ...state,
        getPartsListLoading: false,
        partsList: action?.payload?.parts || [],
      };
    case Actions.GET_ALL_PARTS_LIST_FAIL:
      return {
        ...state,
        getPartsListLoading: false,
        error: action.payload,
      };

    // Export Parts

    case Actions.EXPORT_PARTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Actions.EXPORT_PARTS_SUCCESS:
      return {
        ...state,
        loading: false,
        exportParts: action?.payload || '',
      };
    case Actions.EXPORT_PARTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case Actions.CLEAR_EXPORT_PARTS_STATE:
      return {
        ...state,
        loading: false,
        error: '',
        exportParts: '',
      };

    // Import Parts

    case Actions.IMPORT_PARTS_SUPPLIES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Actions.IMPORT_PARTS_SUPPLIES_SUCCESS:
      const parts = action.payload?.allParts || [];
      return {
        ...state,
        loading: false,
        importPartsSuppliesData: action.payload,
        partsList: parts, // also update the parts list when parts are  imported successfully
      };
    case Actions.IMPORT_PARTS_SUPPLIES_FAIL:
      return {
        ...state,
        loading: false,
        importPartsSuppliesError: action.payload,
      };
    case Actions.CLEAR_IMPORT_PARTS_STATE:
      return {
        ...state,
        loading: false,
        importPartsSuppliesError: '',
        importPartsSuppliesData: '',
      };

    default:
      return state;
  }
};
